/**
 * Hook for managing current user data
 */
import { useQuery } from '@tanstack/react-query';
import { getCurrentUser } from '@lib/api/auth';

export const useCurrentUser = () => {
  return useQuery({
    queryKey: ['currentUser'],
    queryFn: getCurrentUser,
    retry: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
